(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    const DISMISS_DELAY = 4000;
    const SWIPE_THRESHOLD = 80;

    Alpine.data('cartNotification', () => ({
      visible: false,
      type: 'success',
      message: '',
      timeout: null,
      swipe: { startX: 0, currentX: 0, active: false },

      show(type = 'success', customMessage) {
        clearTimeout(this.timeout);
        this.resetStyles();
        this.type = type;
        this.message = customMessage || this.$el.dataset[type === 'error' ? 'messageError' : 'messageAdded'];
        this.visible = true;
        this.startTimer();
      },

      hide() {
        this.visible = false;
        this.swipe.active = false;
        this.resetStyles();
      },

      // Auto-dismiss timer
      startTimer() {
        this.timeout = setTimeout(() => this.hide(), DISMISS_DELAY);
      },

      pause() {
        clearTimeout(this.timeout);
      },

      resume() {
        if (this.visible) this.startTimer();
      },

      // Touch/swipe handling
      touchStart(event) {
        this.swipe.startX = event.touches[0].clientX;
        this.swipe.currentX = this.swipe.startX;
        this.swipe.active = true;
        this.pause();
      },

      touchMove(event) {
        if (!this.swipe.active) return;

        this.swipe.currentX = event.touches[0].clientX;
        const distance = this.swipeDistance;

        if (distance < 0) {
          this.$el.style.transform = `translateX(calc(-50% + ${distance}px))`;
          this.$el.style.opacity = Math.max(0, 1 + distance / 100);
        }
      },

      touchEnd() {
        if (!this.swipe.active) return;

        if (this.swipeDistance < -SWIPE_THRESHOLD) {
          this.hide();
        } else {
          this.resetStyles();
          this.resume();
        }
        this.swipe.active = false;
      },

      // Helpers
      get swipeDistance() {
        return this.swipe.currentX - this.swipe.startX;
      },

      resetStyles() {
        this.$el.style.transform = '';
        this.$el.style.opacity = '';
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-notification"] && !Shopify.designMode) return;
  try {
    class FormNotification {
    visible = true;
    timeout = null;
    dismissDelay = 4000;

    init() {
      this.startTimer();
    }

    startTimer() {
      this.timeout = setTimeout(() => this.dismiss(), this.dismissDelay);
    }

    pause() {
      clearTimeout(this.timeout);
    }

    resume() {
      if (this.visible) {
        this.startTimer();
      }
    }

    dismiss() {
      clearTimeout(this.timeout);
      this.visible = false;
    }
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('formNotification', () => new FormNotification());
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-lightbox"] && !Shopify.designMode) return;
  try {
    class ImageLightbox {
    // Reactive state
    open = false;
    currentIndex = 0;

    // Swipe state
    swipeStartX = null;
    swipeStartY = null;
    swipeThreshold = 50;

    constructor(imageCount) {
      this.imageCount = imageCount;
    }

    // ─────────────────────────────────────────────────────────────
    // Navigation
    // ─────────────────────────────────────────────────────────────

    show(index) {
      this.currentIndex = index;
      this.open = true;
    }

    close() {
      if (this.open) {
        this.open = false;
      }
    }

    goTo(index) {
      this.currentIndex = index;
    }

    prev() {
      if (!this.open) return;
      this.currentIndex = (this.currentIndex - 1 + this.imageCount) % this.imageCount;
    }

    next() {
      if (!this.open) return;
      this.currentIndex = (this.currentIndex + 1) % this.imageCount;
    }

    // ─────────────────────────────────────────────────────────────
    // Swipe gesture
    // ─────────────────────────────────────────────────────────────

    startSwipe(touch) {
      this.swipeStartX = touch.clientX;
      this.swipeStartY = touch.clientY;
    }

    cancelSwipe() {
      this.swipeStartX = null;
      this.swipeStartY = null;
    }

    getSwipeDelta(touch) {
      return {
        x: touch.clientX - this.swipeStartX,
        y: touch.clientY - this.swipeStartY,
      };
    }

    isHorizontalSwipe(delta) {
      return Math.abs(delta.x) > Math.abs(delta.y) && Math.abs(delta.x) > this.swipeThreshold;
    }

    handleSwipe(delta) {
      if (delta.x > 0) {
        this.prev();
      } else {
        this.next();
      }
    }

    // ─────────────────────────────────────────────────────────────
    // Touch event handlers
    // ─────────────────────────────────────────────────────────────

    touchStart(event) {
      // Only track single-finger touches (not pinch)
      if (!this.open || event.touches.length !== 1) {
        this.cancelSwipe();
        return;
      }
      this.startSwipe(event.touches[0]);
    }

    touchEnd(event) {
      if (!this.open || this.swipeStartX === null) return;

      const delta = this.getSwipeDelta(event.changedTouches[0]);

      if (this.isHorizontalSwipe(delta)) {
        this.handleSwipe(delta);
      }

      this.cancelSwipe();
    }
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('imageLightbox', (...args) => new ImageLightbox(...args));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-zoom"] && !Shopify.designMode) return;
  try {
    class ImageZoom {
    // Zoom state
    zoomed = false;
    scale = 1;
    originX = 50;
    originY = 50;
    maxZoom = 3;
    isDesktop = false;

    // Pinch state
    isPinching = false;
    pinchStartDistance = 0;
    pinchStartScale = 1;

    // Drag state
    isDragging = false;
    dragStartX = 0;
    dragStartY = 0;
    dragStartOriginX = 0;
    dragStartOriginY = 0;

    constructor(maxZoom = 3) {
      this.maxZoom = maxZoom;
      this.isDesktop = window.matchMedia('(pointer: fine)').matches;
    }

    get transformStyle() {
      if (this.scale === 1) return '';
      return `transform: scale(${this.scale}); transform-origin: ${this.originX}% ${this.originY}%`;
    }

    // ─────────────────────────────────────────────────────────────
    // Utilities
    // ─────────────────────────────────────────────────────────────

    clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    getDistance(touchA, touchB) {
      const dx = touchA.clientX - touchB.clientX;
      const dy = touchA.clientY - touchB.clientY;
      return Math.hypot(dx, dy);
    }

    getMidpoint(touchA, touchB) {
      return {
        x: (touchA.clientX + touchB.clientX) / 2,
        y: (touchA.clientY + touchB.clientY) / 2,
      };
    }

    getRelativePosition(clientX, clientY, rect) {
      return {
        x: ((clientX - rect.left) / rect.width) * 100,
        y: ((clientY - rect.top) / rect.height) * 100,
      };
    }

    // ─────────────────────────────────────────────────────────────
    // Desktop: Click to zoom
    // ─────────────────────────────────────────────────────────────

    toggle() {
      if (!this.isDesktop) return;

      if (this.scale === 1) {
        this.zoomIn();
      } else {
        this.reset();
      }
    }

    zoomIn() {
      this.scale = this.maxZoom;
      this.zoomed = true;
    }

    // ─────────────────────────────────────────────────────────────
    // Desktop: Mouse pan
    // ─────────────────────────────────────────────────────────────

    pan(event) {
      if (this.scale === 1) return;

      const rect = event.currentTarget.getBoundingClientRect();
      const pos = this.getRelativePosition(event.clientX, event.clientY, rect);
      this.originX = pos.x;
      this.originY = pos.y;
    }

    // ─────────────────────────────────────────────────────────────
    // Touch: Pinch to zoom
    // ─────────────────────────────────────────────────────────────

    startPinch(touches, rect) {
      this.isPinching = true;
      this.isDragging = false;
      this.pinchStartDistance = this.getDistance(touches[0], touches[1]);
      this.pinchStartScale = this.scale;

      const mid = this.getMidpoint(touches[0], touches[1]);
      const pos = this.getRelativePosition(mid.x, mid.y, rect);
      this.originX = pos.x;
      this.originY = pos.y;
    }

    updatePinch(touches) {
      const currentDistance = this.getDistance(touches[0], touches[1]);
      const scaleChange = currentDistance / this.pinchStartDistance;
      this.scale = this.clamp(this.pinchStartScale * scaleChange, 1, this.maxZoom);
      this.zoomed = this.scale > 1;
    }

    endPinch() {
      this.isPinching = false;
    }

    // ─────────────────────────────────────────────────────────────
    // Touch: Drag to pan
    // ─────────────────────────────────────────────────────────────

    startDrag(touch) {
      this.isDragging = true;
      this.dragStartX = touch.clientX;
      this.dragStartY = touch.clientY;
      this.dragStartOriginX = this.originX;
      this.dragStartOriginY = this.originY;
    }

    updateDrag(touch, rect) {
      const deltaX = touch.clientX - this.dragStartX;
      const deltaY = touch.clientY - this.dragStartY;

      // Convert pixel delta to percentage (inverted for natural feel)
      const percentX = (deltaX / rect.width) * 100 * this.scale;
      const percentY = (deltaY / rect.height) * 100 * this.scale;

      this.originX = this.clamp(this.dragStartOriginX - percentX, 0, 100);
      this.originY = this.clamp(this.dragStartOriginY - percentY, 0, 100);
    }

    endDrag() {
      this.isDragging = false;

      // Snap to 1x if barely zoomed
      if (this.scale < 1.1) {
        this.reset();
      }
    }

    // ─────────────────────────────────────────────────────────────
    // Touch event handlers
    // ─────────────────────────────────────────────────────────────

    touchStart(event) {
      const rect = event.currentTarget.getBoundingClientRect();

      if (event.touches.length === 2) {
        this.startPinch(event.touches, rect);
      } else if (event.touches.length === 1 && this.zoomed) {
        this.startDrag(event.touches[0]);
      }
    }

    touchMove(event) {
      if (this.isPinching && event.touches.length === 2) {
        event.preventDefault();
        event.stopPropagation();
        this.updatePinch(event.touches);
      } else if (this.isDragging && event.touches.length === 1) {
        event.preventDefault();
        event.stopPropagation();
        const rect = event.currentTarget.getBoundingClientRect();
        this.updateDrag(event.touches[0], rect);
      }
    }

    touchEnd(event) {
      // Block navigation when interacting with zoom
      if (this.isDragging || this.isPinching) {
        event.stopPropagation();
      }

      if (event.touches.length < 2 && this.isPinching) {
        this.endPinch();
      }

      if (event.touches.length === 0 && this.isDragging) {
        this.endDrag();
      }
    }

    // ─────────────────────────────────────────────────────────────
    // Reset
    // ─────────────────────────────────────────────────────────────

    reset() {
      this.scale = 1;
      this.zoomed = false;
      this.originX = 50;
      this.originY = 50;
    }
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('imageZoom', (maxZoom) => new ImageZoom(maxZoom));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-search"] && !Shopify.designMode) return;
  try {
    const MIN_QUERY_LENGTH = 2;
  const RESULTS_LIMIT = 6;

  class QuickSearch {
    open = false;
    query = '';
    results = [];
    loading = false;
    error = false;
    _controller = null;

    get queryTooShort() {
      const q = this.query.trim();
      return q.length > 0 && q.length < MIN_QUERY_LENGTH;
    }

    show() {
      this.open = true;
      this.$nextTick(() => this.$refs.input?.focus());
    }

    hide() {
      this.open = false;
      this.query = '';
      this.results = [];
      this.error = false;
    }

    onInput() {
      this.error = false;
      if (this.query.trim().length >= MIN_QUERY_LENGTH) {
        this.loading = true;
        this.results = [];
      } else {
        this.loading = false;
      }
    }

    submit() {
      if (!this.query.trim()) return;
      const url = new URL('search', window.origin);
      url.searchParams.set('q', this.query);
      window.location.href = url.href;
    }

    async search() {
      const query = this.query.trim();

      if (query.length < MIN_QUERY_LENGTH) {
        this.results = [];
        this.error = false;
        return;
      }

      this._controller?.abort();
      this._controller = new AbortController();
      this.loading = true;
      this.error = false;

      try {
        const data = await this._fetchSuggestions(query);
        const products = data.resources?.results?.products || [];

        this.results = products.map((product) => ({
          id: product.id,
          title: product.title,
          url: product.url,
          image: product.image,
          price: this._formatMoney(product.price),
        }));
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.results = [];
          this.error = true;
          console.error('Search error:', error);
        }
      } finally {
        this.loading = false;
      }
    }

    async _fetchSuggestions(query) {
      const url = new URL('search/suggest.json', window.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', RESULTS_LIMIT);

      const response = await fetch(url, { signal: this._controller.signal });
      if (!response.ok) throw new Error('Search failed');

      return response.json();
    }

    _formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return window.Shopify.currency.active ? `${amount} ${window.Shopify.currency.active}` : `$${amount}`;
    }

    destroy() {
      this._controller?.abort();
    }
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('quickSearch', () => new QuickSearch());
  });
  } catch(e) { console.error(e); }
})();

})();
